import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from "react-redux";
import { checkAuthenticatedUser } from '../../services/AuthService'

const Protected = ({ children }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isUserAuthenticated, setIsUserAuthenticated] = useState(false);
    useEffect(() => {
        (async() => {
            let isAuthenticated = await checkAuthenticatedUser({ navigate, dispatch });
            console.log("isAuthenticated:", isAuthenticated)
            setIsUserAuthenticated(isAuthenticated)
        })()
    }, [])
    return (
        <div>
            {
                isUserAuthenticated ?
                    children
                    :
                    null
            }
        </div>
    )
}

export default Protected